module.exports = __webpack_public_path__ + "static/media/settings.2b492f07.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dashboard/settings.jpeg
// module id = 583
// module chunks = 0